import React, { FC } from 'react';
import { Table } from 'antd';
import { bidderStatusTextFormatter } from '../../utils/DataFormatterUtils';
import { Link } from 'react-router-dom';
import { FlexibleImageAvatar } from '../flexible-image-avatar/FlexibleImageAvatar';

export const BidderList: FC<any> = (props) => {
	let { bidders } = props;
	const bidderColumns = [
		{
			title: 'Name',
			dataIndex: ['supplierFacility', 'name'],
			key: 'supplierFacility.name',
			render: (text, record) => (
				<Link to={`/buyer/suppliers/detail/${record.supplierFacility.id}`}>
					<div style={{ display: 'flex', alignItems: 'center' }}>
						<div style={{ marginRight: 16 }}>
							<FlexibleImageAvatar
								displayName={text}
								showPopover={false}
								popoverText={text}
								width="40px"
								height="40px"
								imageUrl={record.supplierFacility.logoURL}
							/>
						</div>
						<div style={{ fontSize: 18 }}>{text}</div>
					</div>
				</Link>
			),
		},
		{
			title: 'Status',
			dataIndex: 'bidderStatus',
			key: 'bidderStatus',
			render: (text, record, idx) => {
				return (
					<span className={`bidder__statusText ${text}`} style={{ marginRight: 16 }}>
						{bidderStatusTextFormatter(text)}
					</span>
				);
			},
		},
	];
	return (
		<Table columns={bidderColumns} dataSource={bidders} pagination={false} showHeader={false} />
	);
};
